<div class="wrap">
  <div class="btn_parameters">
    <div class="header">
      <h3>Modifier les boutons d'accès rapide</h3>
      <!-- <div class="btn_action">
        <fa-icon [icon]="faUndoAlt" class="action" (click)="openDialogConfirmReset()"></fa-icon>
        <fa-icon [icon]="faSave" [ngClass]="{confirm_hidden: !confirm, confirm_visible: confirm }"
          (click)="confirm? confirmChange(): ''"></fa-icon>
        <div class="scroll">
          <div (click)="scrollToElement(top)">
            <fa-icon [icon]="faAngleUp"></fa-icon>
          </div>
          <div (click)="scrollToElement(bottom)">
            <fa-icon [icon]="faAngleDown"></fa-icon>
          </div>
        </div>
      </div> -->
    </div>

    <div class="content">

      <div class="btn_action">
        <div (click)="confirm? openDialogConfirmSAve(): cancel()">
          <fa-icon [icon]="faLongArrowAltLeft" class="action"></fa-icon>
        </div>
        <div (click)="openDialogConfirmReset()">
          <fa-icon [icon]="faUndoAlt" class="action"></fa-icon>
        </div>
        <div (click)="confirm? confirmChange(): ''">
          <fa-icon [icon]="faSave" [ngClass]="{confirm_hidden: !confirm, confirm_visible: confirm }"></fa-icon>
        </div>
        <div class="scroll" (click)="scrollToElement(top)">
          <fa-icon [icon]="faAngleUp"></fa-icon>
        </div>
        <div class="scroll" (click)="scrollToElement(bottom)">
          <fa-icon [icon]="faAngleDown"></fa-icon>
        </div>
      </div>


      <div cdkDropList class="list_drag_drop_list" (cdkDropListDropped)="drop($event)" id="scroll"
        [cdkDropListAutoScrollDisabled]="false" actualContainer="div.wrap">
        <div #top></div>
        <ng-container *ngFor="let m of menu">
          <div class="item" cdkDrag (cdkDragStarted)="dragInProgess($event)">
            <div class="item_placeholder" *cdkDragPlaceholder></div>
            <app-icon [itemMenu]="m" [menu]="menu" [isNotUpdate]="m.title_Drawer" (newMenu)="menuUpdate=$event"
              [visibility]="m.visibility" [inMyMenu]=" m.visibilityFlag" [confirm]="confirm">
            </app-icon>
          </div>
        </ng-container>
        <div #bottom class="bottom"></div>
      </div>
    </div>

  </div>



</div>